import './style.scss';

type InfoItemProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
  linkLabel?: string;
  linkUrl?: string;
};

export const InfoItem = ({
  description,
  title,
  icon,
  linkLabel,
  linkUrl,
}: InfoItemProps) => {
  return (
    <div className="info-item">
      <div className="info-item__head">
        {icon}
        <span className="info-item__head-title">
          {title}
        </span>
      </div>
      <span className="text-subtitle-2">
        {description}
        {linkLabel && linkUrl && (
          <a
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="info-item__link"
            data-testid="cart-help-contact-link"
          >
            {linkLabel}
          </a>
        )}
      </span>
    </div>
  );
};
